<template>
    <div class="row">
        <div v-if="user.role.id == 1" class="col-md-12">
            <div class="d-flex align-items-center justify-content-between pb-2">
                <h3 class="mb-0">Materials</h3>
                <div>
                    <span
                        class="add-button btn btn-action"
                        v-if="folderId == '' || folderId == null"
                        @click="openModal(null, 'add', 'folder')"
                    >
                        <i class="fa fa-plus-circle" aria-hidden="true"></i> ADD
                        FOLDER
                    </span>
                    &nbsp;&nbsp;
                    <span
                        class="add-button btn btn-action"
                        @click="openModal(null, 'add', 'material')"
                    >
                        <i class="fa fa-plus-circle" aria-hidden="true"></i> ADD
                        MATERIAL
                    </span>
                </div>
            </div>

            <!-- ADD MATERIAL MODAL-->
            <b-modal
                size="lg"
                v-model="showMaterialModal"
                :title="modalType == 'add' ? 'ADD MATERIAL' : 'EDIT MATERIAL'"
                hide-footer
            >
                <MaterialModal
                    v-if="showMaterialModal"
                    :modal-data="modalData"
                    :modal-type="modalType"
                    @close-modal="closeModal"
                    :currentFolderId="this.folderId"
                />
            </b-modal>

            <!-- ADD MATERIAL FOLDER MODAL -->
            <b-modal
                size="lg"
                v-model="showFolderModal"
                :title="modalType == 'add' ? 'ADD FOLDER' : 'EDIT FOLDER'"
                hide-footer
            >
                <MaterialFolderModal
                    v-if="showFolderModal"
                    :modal-data="modalData"
                    :modal-type="modalType"
                    @close-modal="closeModal"
                />
            </b-modal>

            <!-- CONFIRMATION MODAL -->
            <b-modal v-model="modalShowConfirm" hide-footer>
                <Confirmation
                    v-if="modalShowConfirm"
                    :title="modalShowConfirmText"
                    @custom-func="closeModalFunc"
                    @close-modal="closeModalConfirm"
                />
            </b-modal>
        </div>
    </div>
    <hr />
    <div class="d-flex">
        <button
            class="mr-2"
            v-if="folderId != '' && folderId != null"
            @click="goHome"
        >
            <i class="fas fa-arrow-left"></i>
        </button>
        <div class="">
            <h4 class="mb-0">
                /
                <template v-if="folderName != null"> {{ folderName }}</template>
            </h4>
        </div>
    </div>
    <hr />
    <div class="row">
        <MaterialTileView
            @goToFolder="goToFolder"
            @edit="showEditModal"
            @delete="showDeleteModal"
            :showFolders="!folderId ? true : false"
        />
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore, mapGetters } from "vuex";

import MaterialModal from "@/components/modals/MaterialModal.vue";
import MaterialFolderModal from "@/components/modals/MaterialFolderModal.vue";
import Confirmation from "@/components/Confirmation.vue";
import MaterialTileView from "@/components/material/MaterialTileView.vue";

export default {
    props: [],
    emits: [],
    components: {
        MaterialModal,
        MaterialFolderModal,
        Confirmation,
        MaterialTileView,
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });

        let allMaterials = computed(function () {
            return store.state["material"].allMaterials;
        });

        let allMaterialFolders = computed(function () {
            return store.state["material"].allMaterialFolders;
        });

        onMounted(() => {});

        return {
            store,
            user,
            allMaterials,
            allMaterialFolders,
        };
    },
    data() {
        return {
            showMaterialModal: false,
            showFolderModal: false,
            modalType: null,
            modalData: {},
            modalShowConfirm: false,
            modalShowConfirmText: null,
            closeModalFuncType: null,
            folderId: null,
        };
    },
    computed: {
        folderName() {
            let folderName = null;
            if (this.folderId) {
                let folder = this.allMaterialFolders.filter(
                    (folder) => folder.id == this.folderId
                );
                folderName = folder[0].name;
            }
            return folderName;
        },
    },
    mounted() {
        this.store.dispatch("material/getAllMaterialFolders");
        if (this.$route.params.id != null) {
            this.folderId = this.$route.params.id;
        }
        this.store.dispatch("material/getAllMaterials", this.folderId);

        console.log(this.folderId);
    },
    methods: {
        closeModal() {
            this.showMaterialModal = false;
            this.showFolderModal = false;
            this.modalType = null;
            this.modalData = {};
        },
        closeModalConfirm() {
            this.modalShowConfirm = false;
            this.modalShowConfirmText = null;
            this.modalData = {};
            this.closeModalFuncType = null;
        },
        closeModalFunc() {},
        openModal(data, val, type) {
            this.modalType = val;
            this.modalData = data;
            if (type == "material") {
                this.showMaterialModal = !this.showMaterialModal;
            } else {
                this.showFolderModal = !this.showFolderModal;
            }
        },
        goToFolder(id) {
            this.store.commit("material/setAllMaterials", []);
            this.$router.push({
                name: "materials",
                params: {
                    id: id,
                },
            });
        },
        goHome() {
            this.store.commit("material/setAllMaterials", []);
            this.$router.push({
                name: "materials",
            });
        },
        showEditModal(data) {
            this.modalType = "edit";
            this.modalData = data.data;

            if (data.type == "file" || data.type == "file_folder") {
                this.showMaterialModal = true;
                if (data.type == "file_folder") {
                    this.modalType = "file_folder";
                }
            } else {
                this.showFolderModal = true;
            }
        },
        showDeleteModal(data) {
            this.modalData = data.data;
            this.modalShowConfirm = true;
            if (data.type == "file") {
                this.modalShowConfirmText =
                    "Are you sure you want to delete this file?";
                this.closeModalFuncType = "deleteFile";
            } else {
                this.modalShowConfirmText =
                    "Are you sure you want to delete this folder?";
                this.closeModalFuncType = "deleteFolder";
            }
        },

        closeModalFunc() {
            if (this.closeModalFuncType == "deleteFile") {
                let data = {
                    id: this.modalData.id,
                };
                this.store
                    .dispatch("material/deleteMaterial", data)
                    .then((resp) => {
                        window.emitter.emit("alertSuccess", {
                            message: "File deleted successfully!",
                        });
                        this.store.dispatch(
                            "material/getAllMaterials",
                            this.folderId
                        );
                        this.closeModalConfirm();
                    });
            } else if (this.closeModalFuncType == "deleteFolder") {
                let data = {
                    id: this.modalData.id,
                };
                this.store
                    .dispatch("material/deleteMaterialFolder", data)
                    .then((resp) => {
                        window.emitter.emit("alertSuccess", {
                            message: "Folder deleted successfully!",
                        });
                        this.store.dispatch("material/getAllMaterialFolders");
                        this.closeModalConfirm();
                    });
            }
        },
    },
};
</script>
